import React from "react";
import Optime from "./Optime/Optime";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import createSagaMiddleware from "redux-saga";

import {
  watchHub,
  watchAuth,
  watchMain,
  watchPlan,
  watchView,
  watchDriverLog,
  watchAnalytics,
  watchDriverManagement,
} from "./Store/Sagas/Saga";

import { Provider } from "react-redux";
import { HubReducer } from "./Store/Reducers/MicroHubsReducer/Reducer";
import { MainReducer } from "./Store/Reducers/MainReducer/Reducer";
import { PlanReducer } from "./Store/Reducers/PlanReducer/Reducer";
import { AuthReducer } from "./Store/Reducers/AuthReducer/Reducer";
import { watchOrgAdmin } from "./OrganizationAdminDashborad/Store/Saga/Saga";
// import { PostHogProvider } from "posthog-js/react";
import { watchSuperAdmin } from "./SuperAdmin/Store/Saga/Saga";
import { watchOrgManager } from "./OrganizationDashboard/Store/Saga/Saga";
import { PlanViewReducer } from "./Store/Reducers/PlanViewReducer/Reducer";
import { OrgAdminReducer } from "./OrganizationAdminDashborad/Store/Reducer/Reducer";
import { DriverLogReducer } from "./Store/Reducers/DriverLogReducer/Reducer";
import { AnalyticsReducer } from "./Store/Reducers/Analytics/Reducer";
import { SuperAdminReducer } from "./SuperAdmin/Store/Reducer/Reducer";
import { OrgManagerReducer } from "./OrganizationDashboard/Store/Reducer/Reducer";
import { DriverManagementReducer } from "./Store/Reducers/DriverManagementReducer/Reducer";
import { createStore, applyMiddleware, combineReducers } from "redux";

import "./index.css";
// leaflet css files
import "leaflet/dist/leaflet.css";
import "leaflet-routing-machine/dist/leaflet-routing-machine.css";
import L from 'leaflet';

L.Icon.Default.mergeOptions({
  iconUrl: '/marker-icon.png',
  iconRetinaUrl: '/marker-icon.png',
});

// import { composeWithDevTools } from "redux-devtools-extension";

const rootReducer = combineReducers({
  // New reducer most deploy here
  hub: HubReducer,
  main: MainReducer,
  auth: AuthReducer,
  plan: PlanReducer,
  view: PlanViewReducer,
  orgAdmin: OrgAdminReducer,
  analytics: AnalyticsReducer,
  driverLog: DriverLogReducer,
  superAdmin: SuperAdminReducer,
  orgManager: OrgManagerReducer,
  driverManagement: DriverManagementReducer,
});

const sagaMiddleware = createSagaMiddleware();

// export const ReduxStore = createStore(
//   rootReducer,
//   composeWithDevTools(applyMiddleware(sagaMiddleware))
// );
export const ReduxStore = createStore(
  rootReducer,
  applyMiddleware(sagaMiddleware)
);

window.addEventListener("error", (e) => {
  // prompt user to confirm refresh
  if (/Loading chunk [\d]+ failed/.test(e.message)) {
    window.location.reload();
  }
});

sagaMiddleware.run(watchHub);
sagaMiddleware.run(watchMain);
sagaMiddleware.run(watchAuth);
sagaMiddleware.run(watchPlan);
sagaMiddleware.run(watchView);
sagaMiddleware.run(watchOrgAdmin);
sagaMiddleware.run(watchAnalytics);
sagaMiddleware.run(watchDriverLog);
sagaMiddleware.run(watchSuperAdmin);
sagaMiddleware.run(watchOrgManager);
sagaMiddleware.run(watchDriverManagement);

// const options = {
//   api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
// };

ReactDOM.render(
  // <PostHogProvider
  //   apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY}
  //   options={options}
  // >
  <Provider store={ReduxStore}>
    <Optime />
  </Provider>,
  // </PostHogProvider>

  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
